import { useEffect, useState } from 'react';
import { useIsMutating, useIsFetching } from '@tanstack/react-query';

export function GlobalLoadingIndicator() {
    const isMutating = useIsMutating();
    const refetchingCount = useIsFetching({
        predicate: (query) => query.state.data !== undefined,
    });
    const isLoading = isMutating > 0 || refetchingCount > 0;
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (isLoading) {
            const timer = setTimeout(() => setShow(true), 150);
            return () => clearTimeout(timer);
        }
        setShow(false);
    }, [isLoading]);

    if (!show) return null;

    return (
        <div className="fixed top-0 left-0 right-0 z-50 h-0.5 overflow-hidden bg-accent/20">
            <div className="h-full w-1/3 bg-accent animate-nprogress" />
        </div>
    );
}
